module.exports = __webpack_public_path__ + "img/vue.d6395cc7.png";